const N8N_WEBHOOK = 'https://n8n.gubk.ru/webhook/966b2af0-fbb8-44de-997f-931133901as1cd';
const STORAGE_KEY = 'exchange_cabinet_auth';
const TOKEN_LIFETIME_DAYS = 30;

export const authService = {
  saveAuth(masterId, token) {
    const data = {
      masterId,
      token,
      expiresAt: Date.now() + TOKEN_LIFETIME_DAYS * 24 * 60 * 60 * 1000
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  },

  getAuth() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    
    const data = JSON.parse(raw);
    if (Date.now() > data.expiresAt) {
      this.logout();
      return null;
    }
    return { masterId: data.masterId, token: data.token };
  },

  logout() {
    localStorage.removeItem(STORAGE_KEY);
  },

  async login(email, token) {
    const response = await fetch(N8N_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'exchange_auth', email, token })
    });
    
    if (!response.ok) throw new Error('Network error');
    
    const result = await response.json();
    
    if (result.authorized && result.masterId) {
      this.saveAuth(result.masterId, token);
      return { success: true, masterId: result.masterId };
    }
    
    return { success: false, error: result.message || 'Auth failed' };
  },

  async validateToken() {
    const auth = this.getAuth();
    if (!auth) return false;

    const response = await fetch(N8N_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'exchange_validate',
        masterId: auth.masterId,
        token: auth.token
      })
    });

    const result = await response.json();
    if (!result.valid) {
      this.logout();
      return false;
    }
    return true;
  },

  async getCabinetData() {
    const auth = this.getAuth();
    if (!auth) throw new Error('Not authenticated');

    const response = await fetch(N8N_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'exchange_get_data',
        masterId: auth.masterId,
        token: auth.token
      })
    });

    if (!response.ok) throw new Error('Network error');
    
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Failed to load data');
    
    return result;
  },

  async buyRequest(requestId) {
    const auth = this.getAuth();
    if (!auth) throw new Error('Not authenticated');

    const response = await fetch(N8N_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'exchange_buy_request',
        masterId: auth.masterId,
        token: auth.token,
        requestId: requestId
      })
    });

    if (!response.ok) throw new Error('Network error');
    
    const result = await response.json();
    if (!result.success) {
      throw new Error(result.message || 'Failed to buy request');
    }
    
    return result;
  },

  async getPaymentLink(amount) {
    const auth = this.getAuth();
    if (!auth) throw new Error('Not authenticated');

    const response = await fetch(N8N_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'get_payment_link',
        masterId: auth.masterId,
        token: auth.token,
        amount: amount
      })
    });

    if (!response.ok) throw new Error('Network error');
    
    const result = await response.json();
    if (!result.success || !result.paymentUrl) {
      throw new Error(result.message || 'Failed to get payment link');
    }
    
    return result.paymentUrl;
  },

  async getRequestDetail(requestId) {
    const auth = this.getAuth();
    if (!auth) throw new Error('Not authenticated');

    const response = await fetch(N8N_WEBHOOK, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'get_request_detail',
        masterId: auth.masterId,
        token: auth.token,
        requestId: requestId
      })
    });

    if (!response.ok) throw new Error('Network error');
    
    const result = await response.json();
    if (!result.success) {
      throw new Error(result.message || 'Failed to load request details');
    }
    
    return result.data;
  }
};